import { Message } from "element-ui";

var XSKeyInterface;
/**
 * @description 电子锁页面初始化
 */
export const fun_LoadXSKeyInterface = () => {
  var XSKeyCount;
  try{
    // 创建XSKey加密狗控件
    if (document.implementation && document.implementation.createDocument && typeof XSLTProcessor != 'undefined'){
      XSKeyInterface= document.getElementById('XSKeyInterface');
    } else {
      XSKeyInterface=new ActiveXObject("XSKeyActiveX.XSKeyInterface.1");
    }

    var XSKeyCount;
    XSKeyCount = XSKeyInterface.IXSKeyFind();
  }catch(e){
    Message.error(
        "没有安装工作人员密保锁网页控件, 请安装工作人员密保锁网页控件！",
        "提示",
        { type: "warning" }
    );
    return false;
  }
  XSKeyInterface.IXSKeyLogoff(0);
  return true;
};

/**
 * 查找加密锁
 * @return
 */
export const fun_XSKeyFind = () => {
  var XSKeyCount;
  XSKeyCount = XSKeyInterface.IXSKeyFind();
  if(XSKeyInterface.IXSKeyGetLastError() == 0){
    return XSKeyCount;
  }else{
    return 0;
  }
};
/**
 * 获取硬件序列号
 * @return
 */
export const fun_XSKeyHID = () => {
  var XSKeyIndex;
  var XSKeyHID="";

  XSKeyIndex = 0;
  XSKeyHID = XSKeyInterface.IXSKeyGetHID(XSKeyIndex);

  if(XSKeyInterface.IXSKeyGetLastError() == 0){
    return XSKeyHID;
  }else{
    return '';
  }
};
/**
 *  以用户权限登录
 * @return
 */
export const fun_XSKeyUserLogon = (passWord) => {
  var XSKeyIndex;
  XSKeyIndex = 0;
  XSKeyInterface.IXSKeyUserLogon(XSKeyIndex, passWord);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return '';
  }else{
    return '密保锁用户登录失败！';
  }
};
/**
 *  以管理员权限登录
 * @return
 */
export const fun_XSKeyAdminLogon = (passWord) => {
  var XSKeyIndex;
  XSKeyIndex = 0;
  XSKeyInterface.IXSKeyAdminLogon(XSKeyIndex, passWord);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return '';
  }else{
    return '密保锁管理员登录失败！';
  }
};
/**
 *  修改用户密码
 * @return
 */
export const fun_XSKeySetUserPassword = (passWord) => {
  var XSKeyIndex;
  XSKeyIndex = 0;
  XSKeyInterface.IXSKeySetUserPassword(XSKeyIndex, passWord);
  if(XSKeyInterface.IXSKeyGetLastError() ==0) {
    return '';
  } else {
    return '密保锁用户密码设置错误！';
  }
};
/**
 *  修改管理员密码
 * @return
 */
export const fun_XSKeySetAdminPassword = (passWord) => {
  var XSKeyIndex;
  XSKeyIndex = 0;
  XSKeyInterface.IXSKeySetAdminPassword(XSKeyIndex, passWord);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return '';
  }else{
    return '密保锁管理员密码设置错误！';
  }
};
/**
 *  写数据到XSKey
 * @return
 */
export const fun_XSKeyWriteData = (value) => {
  var XSKeyIndex;
  var Addr= 0;
  var Length = 500;
  XSKeyIndex = 0;
  XSKeyInterface.IXSKeyWriteData(XSKeyIndex, Addr, Length, value);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return value;
  }else {
    return '';
  }
};
/**
 *  数据读取
 * @return
 */
export const fun_XSKeyReadData = () => {
  var XSKeyIndex;
  var Addr = 0;
  var Length = 500;
  var buffer="";
  XSKeyIndex = 0;
  buffer = XSKeyInterface.IXSKeyReadData(XSKeyIndex, Addr, Length);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return buffer;
  }else{
    return '';
  }
};
/**
 *  设置MD5的Key
 * @return
 */
export const fun_XSKeySetMd5Key = (value) => {
  var XSKeyIndex;
  XSKeyIndex = 0;
  XSKeyInterface.IXSKeySetMD5Key(XSKeyIndex, value);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return '';
  }else{
    return '设置MD5Key失败 ！';
  }
};
/**
 *  计算MD5值
 * @return
 */
export const fun_XSKeyHmacMD5 = (value) => {
  var XSKeyIndex;
  var maxLen = 32;
  var buffer="";
  XSKeyIndex = 0;
  // 内容长度
  if(value.length < maxLen){
    var len = maxLen - value.length;
    for(let i=0; i < len; i++){
      value = value + '1';
    }
  }
  buffer = XSKeyInterface.IXSKeyHmacMD5(XSKeyIndex, maxLen, value);
  if(XSKeyInterface.IXSKeyGetLastError() ==0){
    return buffer;
  } else {
    return "HMAC-计算失败 ERRORCODE："+ XSKeyInterface.IXSKeyGetLastError();
  }
};